import React from 'react'
import { connect } from 'react-redux'
import allRoles from '../../roles/roles'
import { addListItem, changeListItem, deleteListItem, getListFromValues, hasChangedValues, getFormValue, changeItemsValue, nullDate } from '../../public/utility'
import { concat } from 'lodash'


class SupplierContactDiv extends React.Component {
    state = {}
    componentDidMount = () => {
        const { id } = this.props
        Tyan.doPostEvent({
            event: 'GetSupplierContact',
            data: { id },
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                this.setState({ id, initValues基本信息, changedValues基本信息: {} })
            }
        })
    }

    handlerSave = () => {
        const { SupplierID, onClose, onSave } = this.props
        const { id, changedValues基本信息, } = this.state
        Tyan.doPostEvent({
            event: 'SaveSupplierContact',
            data: { id, SupplierID, changedValues基本信息 },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                Ext.toast('保存成功')
                onClose && onClose()
                onSave && onSave()
            }
        })
    }

    handlerDelete = () => {
        const { onClose, onSave } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteSupplierContact',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    Ext.toast('删除成功')
                    onClose && onClose()
                    onSave && onSave()
                }
            }))
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    canSave = () => {
        return getFormValue(this, '基本信息', '姓名')
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        return [
            { _text: '姓名', minWidth: '95%', required: true },
            { _text: '联系电话', minWidth: '95%' },
            { _text: '邮箱', minWidth: '95%' },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, bReadOnly, readOnly } = this.props
        const { errorMessage, initValues基本信息, id } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        if (errorMessage) return <Message text={errorMessage} />
        const canSave = this.canSave()
        const bChanged = this.bChanged()
        return <Body data={this} maxWidth="700"
            controls={
                (bReadOnly || readOnly) ?
                    [
                        { _button: bChanged && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    ] : [
                        { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !(canSave && bChanged) },
                        { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                        { _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly || readOnly },
                ]}
        />
    }
}

export default connect()(SupplierContactDiv)